import React, { useEffect, useState, useCallback } from "react";
import { Table, Tag, Select, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { fetchCrmAuditLogApi } from "../../../../apiservice/crm";

const { Text } = Typography;

const ACTION_COLOR = { update: "blue", delete: "red" };

const AuditLog = ({ users = [] }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [userFilter, setUserFilter] = useState(undefined);
  const [recordTypeFilter, setRecordTypeFilter] = useState(undefined);

  const pageSize = 20;

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchCrmAuditLogApi({
        page,
        page_size: pageSize,
        user_id: userFilter,
        record_type: recordTypeFilter,
      });
      setRows(res.data?.rows || []);
      setTotal(res.data?.total || 0);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [page, userFilter, recordTypeFilter]);

  useEffect(() => {
    load();
  }, [load]);

  const goToRecord = (row) => {
    if (row.action === "delete") return;
    if (row.record_type === "lead") navigate(`/crm/leads/${row.record_id}`);
    if (row.record_type === "deal") navigate(`/crm/deals/${row.record_id}`);
  };

  const columns = [
    { title: "When", dataIndex: "created_at", render: (v) => (v ? new Date(v).toLocaleString() : "-"), width: 170 },
    { title: "User", dataIndex: "user_name", render: (v) => v || "-" },
    {
      title: "Record Type",
      dataIndex: "record_type",
      width: 110,
      render: (v) => <Tag>{v}</Tag>,
    },
    {
      title: "Record",
      dataIndex: "record_name",
      render: (v, row) => (
        <Text
          onClick={() => goToRecord(row)}
          style={row.action !== "delete" ? { color: "#1677ff", cursor: "pointer" } : undefined}
        >
          {v || "-"}
        </Text>
      ),
    },
    { title: "Field", dataIndex: "field", render: (v) => v || "-", width: 110 },
    {
      title: "Change",
      render: (_, row) =>
        row.action === "delete"
          ? "-"
          : `${row.old_value ?? "-"} → ${row.new_value ?? "-"}`,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 90,
      render: (v) => <Tag color={ACTION_COLOR[v] || "default"}>{v}</Tag>,
    },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 12 }} wrap>
        <Select
          allowClear
          placeholder="Filter by user"
          style={{ width: 220 }}
          value={userFilter}
          onChange={(v) => { setUserFilter(v); setPage(1); }}
          options={(users || []).map((u) => ({ label: u.full_name, value: u.id }))}
          showSearch
          optionFilterProp="label"
        />
        <Select
          allowClear
          placeholder="Filter by record type"
          style={{ width: 180 }}
          value={recordTypeFilter}
          onChange={(v) => { setRecordTypeFilter(v); setPage(1); }}
          options={[
            { label: "Lead", value: "lead" },
            { label: "Deal", value: "deal" },
          ]}
        />
      </Space>

      <Table
        rowKey="id"
        dataSource={rows}
        columns={columns}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: false,
          onChange: setPage,
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default AuditLog;
